import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import useQuestionnaireStore from '../store/useQuestionnaireStore.js';
import useWarning from '../hooks/useWarningModal.js';
import { ChevronLeft, Check, X } from 'lucide-react';
import Button from '../components/common/Button';

const Step9_Symptoms = () => {
    const navigate = useNavigate();
    const { 
        hasSwelling, 
        setHasSwelling,
        worsensWithPressure, 
        setWorsensWithPressure 
    } = useQuestionnaireStore();
    
    const showWarning = useWarning();

    const handleNext = () => {
        if (hasSwelling === null) {
            showWarning("Please answer if you have swelling.");
            return;
        }
        if (worsensWithPressure === null) {
            showWarning("Please answer if pressure worsens the pain.");
            return;
        }
        
        console.log("Has Swelling:", hasSwelling);
        console.log("Worsens with Pressure:", worsensWithPressure);
        
        // This is usually the last step, so you might navigate to a Summary or Result page
        navigate('/step-10'); 
    };

    const containerVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { 
            opacity: 1, 
            y: 0, 
            transition: { duration: 0.4, staggerChildren: 0.1 } 
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 }
    };

    return (
        <motion.div
            className="page step9-page"
            initial="hidden"
            animate="visible"
            exit={{ opacity: 0, y: -20 }}
            variants={containerVariants}
        >
            <div className="step-header">
                <button onClick={() => navigate(-1)} className="back-button">
                    <ChevronLeft size={20} /> Back
                </button>
                <h2>Physical Symptoms</h2>
            </div>

            <div className="questions-container">
                
                {/* Question 1: Swelling */}
                <motion.div className="question-card" variants={itemVariants}>
                    <div className="card-header">
                        <span className="q-number">01</span>
                        <h3>Do you have swelling on the joint?</h3>
                    </div>
                    <div className="options-row">
                        <button
                            className={`option-btn yes ${hasSwelling === true ? 'selected' : ''}`}
                            onClick={() => setHasSwelling(true)}
                        >
                            <span className="icon"><Check size={20} /></span>
                            Yes
                        </button>
                        <button
                            className={`option-btn no ${hasSwelling === false ? 'selected' : ''}`}
                            onClick={() => setHasSwelling(false)}
                        >
                            <span className="icon"><X size={20} /></span>
                            No
                        </button>
                    </div>
                </motion.div>

                {/* Question 2: Pressure */}
                <motion.div className="question-card" variants={itemVariants}>
                    <div className="card-header">
                        <span className="q-number">02</span>
                        <h3>Does the pain worsen with pressure on a specific point?</h3>
                    </div>
                    <div className="options-row">
                        <button
                            className={`option-btn yes ${worsensWithPressure === true ? 'selected' : ''}`}
                            onClick={() => setWorsensWithPressure(true)}
                        >
                            <span className="icon"><Check size={20} /></span>
                            Yes
                        </button>
                        <button
                            className={`option-btn no ${worsensWithPressure === false ? 'selected' : ''}`}
                            onClick={() => setWorsensWithPressure(false)}
                        >
                            <span className="icon"><X size={20} /></span>
                            No
                        </button>
                    </div>
                </motion.div>

            </div>

            <div className="navigation-buttons">
                <Button onClick={handleNext}>Next</Button>
            </div>
        </motion.div>
    );
};

export default Step9_Symptoms;